import { render, staticRenderFns } from "./RedFlagDisplayer.vue?vue&type=template&id=38aba9ea&scoped=true"
import script from "./RedFlagDisplayer.vue?vue&type=script&lang=js"
export * from "./RedFlagDisplayer.vue?vue&type=script&lang=js"
import style0 from "./RedFlagDisplayer.vue?vue&type=style&index=0&id=38aba9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aba9ea",
  null
  
)

export default component.exports